<template>
    <div>
        Aba Cockpit
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            msgs: [],
        }
    },

    created () {
    },
    mounted () {
    },
    methods: {
        showMessage (type, message) {
            let data = {
                type: type,
                message: message
            };

            this.$emit('alert', data);
        },
    },
}
</script>

<style lang="scss">
</style>

